module.exports = __webpack_public_path__ + "static/media/th-list.828a029b.svg";